"use strict";

import Vue from "vue";
import axios from "axios";
import store from "@/store/";

let config = {
// Full config:  https://github.com/axios/axios#request-config
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

function censor(censor) {
  var i = 0;

  return function(key, value) {
    if(i !== 0 && typeof(censor) === 'object' && typeof(value) == 'object' && censor == value) 
      return '[Circular]'; 

    if(i >= 29) // seems to be a harded maximum of 30 serialized objects?
      return '[Unknown]';

    ++i; // so we know we aren't using the original object anymore

    return value;  
  }
}

// apply interceptor on response
_axios.interceptors.response.use(
  response => response,
  function(error) {
    Vue.$log.debug("msg:" + error.message)
    Vue.$log.debug("error:" + error)
    Vue.$log.debug("error: " + JSON.stringify(error, censor(error), 2));
    Vue.$log.debug("error.response: " + JSON.stringify(error.response, censor(error.response), 2));
    if (error.response.status === 403) {
      Vue.$log.debug("error.response: " + error.response.data);
      Vue.nextTick(function() {
        store.state.errormessage = error.response.data;
      }, this);
      store.commit("mLogout");
      Vue.router.push({ name: "login" });
      return Promise.reject(error);
    }
    store.commit("mHideLongLoader");
    if (error.response && error.response.data) {
      store.state.errormessage = "";
      if (error.response.data.errormessage) {
        Vue.nextTick(function() {
          store.state.errormessage = error.response.data.errormessage;
          if (error.response.data.stacktrace != null)
            Vue.$log.error(error.response.data.stacktrace)
        }, this);
      } else {
        Vue.nextTick(function() {
          store.state.errormessage = error.response.data;
        }, this);
      }
    } else {
      if (error.message) {
        Vue.nextTick(function() {
          store.commit("mShowErrorMessage", error.message)
        }, this);
      }
    }
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue /*, options*/) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
